import type { Check } from './types'
import type {
  CopyPreviousLedgerDataParameters,
  FillOpenTransactionsDataParameters,
} from '@app/shared/types/sf-data'
import { copyPreviousLedgerData } from './actions/copy-previous-ledger-data'
import { fillOpenTransactionsData } from './actions/fill-open-transactions-data'
import { changeAccountDetailTemplate } from './actions/change-account-detail-template'
import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'

import { decamelizeKeys } from 'humps'

export async function triggerAction(
  check: Check,
  currentLocale: string
): Promise<void> {
  const action = check.text[currentLocale]?.action
  switch (action?.actionType) {
    case 'copy_previous_ledger_data':
      await copyPreviousLedgerData(
        action.parameters as CopyPreviousLedgerDataParameters
      )
      break
    case 'fill_open_transactions_data':
      fillOpenTransactionsData(
        action.parameters as FillOpenTransactionsDataParameters
      )
      break
    case 'change_account_detail_template':
      changeAccountDetailTemplate(action)
      break
    default:
      return runGenericAction(check, currentLocale)
  }
}

export function runGenericAction(check: Check, currentLocale: string): void {
  try {
    const path = window.Silverfin.Routes[
      'action_ledger_assistant_checks_v2_index_path'
    ](
      window.Silverfin.currentFirmId,
      window.Silverfin.currentCompanyId,
      window.Silverfin.currentLedgerId()
    )

    SFetch.postFormRedirect({
      url: path,
      method: 'post',
      authenticityToken: window.Silverfin.csrfToken(),
      data: [
        {
          key: 'payload',
          value: JSON.stringify(decamelizeKeys(check)),
        },
        {
          key: 'locale',
          value: currentLocale,
        },
      ],
    })
  } catch (error) {
    SfLog.error('Request failed', {
      extra: {
        error: error,
      },
    })
  }
}
